import * as THREE from 'three';
import { MeshBasicMaterial } from 'three';
import gsap from 'gsap';

export class LogoType extends THREE.Mesh{

    public static mat:THREE.MeshBasicMaterial;

    alwaysVisible:boolean=false;


    constructor(m:THREE.Mesh){

        if( LogoType.mat == null ){
            LogoType.mat = new MeshBasicMaterial({color:0x000000});
        }

        super(
            m.geometry,
            LogoType.mat
        );
        //this.visible=false;

    }

    showLogo(brightness:number){
        this.visible=true;
        LogoType.mat.color.r = brightness;
        LogoType.mat.color.g = brightness;
        LogoType.mat.color.b = brightness;
    }

    hideLogo(){
        this.visible=false;
    }

    blink(ratio:number){

        LogoType.mat.color.r = 0.6 * ratio;
        LogoType.mat.color.g = 0.6 * ratio;
        LogoType.mat.color.b = 0.6 * ratio;
        
        gsap.to(LogoType.mat.color,{
            r:0.05 * ratio,
            g:0.05 * ratio,
            b:0.05 * ratio,
            duration:0.9,
            ease:"linear"
        });

    }



}